module.exports = "/static/assets/4bfa4db4f366febfd0a820b1655623dc.png";